import { useEffect } from 'react';

import { getComparisonOperatorColor } from 'pages/GatewayRules/utils/getComparisonOperatorColor';
import { Controller, useFormContext } from 'react-hook-form';
import { Box } from 'shared/mui/Box';
import { MenuItem } from 'shared/mui/MenuItem/MenuItem';
import { Select } from 'shared/mui/Select/Select';
import { ComparisonOperator } from 'types/embedded/gatewayRule';

import { StyledExpressionFormControl } from './GatewayRulesFormRuleExpression.styled';

type Props = {
  name: string;
  comparisonOperators: ComparisonOperator[];
  expressionParamName?: string;
  isColored?: boolean;
};

export function GatewayRulesFormRuleExpressionOperator({
  name,
  comparisonOperators,
  expressionParamName,
  isColored,
}: Props): JSX.Element {
  const { control, setValue, getValues, resetField } = useFormContext();

  const renderDescription = (operator?: ComparisonOperator) =>
    isColored ? (
      <Box component="span" sx={{ color: getComparisonOperatorColor(operator) }}>
        {operator?.description}
      </Box>
    ) : (
      operator?.description
    );

  const renderValue = (currentValue: string | ComparisonOperator) => {
    const currentId =
      typeof currentValue === 'string' ? currentValue.match(/[^/]+$/)?.[0] : currentValue.id;

    return renderDescription(
      comparisonOperators.find((operator) => `${operator.id}` === currentId),
    );
  };

  useEffect(() => {
    const currentValue = getValues(name);
    if (typeof currentValue !== 'string' && !!currentValue) {
      resetField(name, { defaultValue: `/admin/comparison_operators/${currentValue?.id}` });
    }
  }, [expressionParamName]); // Согласно контракту приводим значение к строке при обновлении условия

  return (
    <StyledExpressionFormControl>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Select
            size="small"
            variant="outlined"
            {...field}
            onChange={(event) => {
              const { name, value } = event.target;

              if (typeof value !== 'string') {
                setValue(name, `/admin/comparison_operators/${value.id}`);
                field.onChange(`/admin/comparison_operators/${value.id}`);
              } else {
                setValue(name, value);
                field.onChange(value);
              }
            }}
            renderValue={renderValue}
            value={field.value}
          >
            {comparisonOperators.map((operator) => {
              return (
                <MenuItem key={operator.id} value={operator as any}>
                  {renderDescription(operator)}
                </MenuItem>
              );
            })}
          </Select>
        )}
      />
    </StyledExpressionFormControl>
  );
}
